import type { Cart } from '@/lib/types';
import { detailView } from '@/lib/display';
import { HeroBattery, PinMark, StatusMark } from '@/components/marks';

interface DetailProps {
  storeName: string;
  cart: Cart;
  onBack: () => void;
}

export function Detail({ storeName, cart, onBack }: DetailProps) {
  const v = detailView(cart);
  return (
    <div className="app-scroll h-full px-[18px] pb-10 pt-[26px]" style={{ flex: '0 0 33.3333%' }}>
      <div
        onClick={onBack}
        className="inline-flex cursor-pointer items-center gap-2 py-0.5 pr-2 text-sm font-bold text-sub"
      >
        <span className="text-lg">‹</span> {storeName}
      </div>
      <div className="mb-1 mt-5 text-[32px] font-extrabold leading-[1.1] text-ink">{cart.name}</div>
      <div className="text-[13px] font-semibold text-faint">{v.serial}</div>
      {v.lastHeard && (
        <div className="mt-1.5 text-sm font-bold" style={{ color: v.lastHeardColor }}>
          {v.lastHeard}
        </div>
      )}
      <div className="mt-5 flex items-center gap-[18px] rounded-hero bg-card px-5 py-[22px] shadow-soft">
        <HeroBattery pct={cart.pct} plugged={cart.plugged} fill={v.battFill} border={v.battBorder} />
        <div className="text-[38px] font-extrabold leading-none" style={{ color: v.heroColor }}>
          {cart.pct}%
        </div>
      </div>
      <div className="mt-[9px] grid grid-cols-2 gap-[9px]">
        <div className="flex items-center gap-3 rounded-card bg-card px-4 py-[18px] shadow-soft">
          <PinMark color={v.pinColor} w={23} h={27} />
          <div>
            <div className="text-[15px] font-bold" style={{ color: v.zoneColor }}>
              {v.zoneText}
            </div>
            <div className="mt-0.5 text-[11.5px] font-semibold text-faint">Geofence</div>
          </div>
        </div>
        <div className="flex items-center gap-3 rounded-card bg-card px-4 py-[18px] shadow-soft">
          <StatusMark err={cart.err} triColor={v.triColor} chkColor={v.chkColor} w={26} h={24} />
          <div>
            <div className="text-[15px] font-bold" style={{ color: v.errColor }}>
              {v.errText}
            </div>
            <div className="mt-0.5 text-[11.5px] font-semibold text-faint">Status</div>
          </div>
        </div>
      </div>
    </div>
  );
}
